module.exports = __webpack_public_path__ + "img/urAssessmentWhite.bb2d5a92.svg";